module.exports = __webpack_public_path__ + "img/home.585c270d.svg";